import {Tooltip, Zoom} from "@mui/material";
import {KTSVG} from "../../_metronic/helpers";

/**
 * Выводит иконки с тултипом для булевых параметров
 * Если текст тултипов не подписан, подсказки не выводятся
 *
 * @param value
 * @param trueTooltipText
 * @param falseTooltipText
 */
export const renderYesNoIcon = (value: boolean, trueTooltipText: string = "", falseTooltipText: string = "") => {
  const trueIcon = <KTSVG
    path='/media/icons/duotune/general/gen037.svg'
    className='svg-icon-1 svg-icon-success'
  />

  const falseIcon = <KTSVG
    path='/media/icons/duotune/general/gen034.svg'
    className='svg-icon-1 svg-icon-danger'
  />

  const trueValue = trueTooltipText
    ? <Tooltip
      placement={'top'}
      TransitionComponent={Zoom}
      title={trueTooltipText}
    >
      <span>{trueIcon}</span>
    </Tooltip>
    : trueIcon

  const falseValue = falseTooltipText
    ? <Tooltip
      placement={'top'}
      TransitionComponent={Zoom}
      title={falseTooltipText}
    >
      <span>{falseIcon}      </span>
    </Tooltip>
    : falseIcon

  return value ? trueValue : falseValue;
}
